import React, { useMemo } from 'react';
import { useAccessibleAccounts } from '../../modules/emails/useData';
import { resolveLastSyncInfo } from '../../modules/emails/utils/lastSyncHint';
import { LastSyncFooter } from '../../modules/emails/components/LastSyncFooter';

/** Last mailbox sync status for the global app footer (left side). */
export const AppFooterLastSync: React.FC = () => {
  const { data: accounts, isError } = useAccessibleAccounts();
  const lastSyncInfo = useMemo(() => resolveLastSyncInfo(accounts), [accounts]);

  if (isError || accounts.length === 0 || lastSyncInfo.status === 'empty') {
    return null;
  }

  return <LastSyncFooter info={lastSyncInfo} variant="appFooter" />;
};

export default AppFooterLastSync;
